/**
 * The one address the site lives on.
 *
 * Every page — the landing, home, rooms, sign-in — is served on the root
 * domain. Every subdomain is a hosting-owned redirect alias, so the application
 * never sends a visitor between names.
 */

/** The only host that renders the published site. */
export const CANONICAL_HOSTS = ["syncani.com"] as const;

/** The single public origin. */
export const SITE_ORIGIN = "https://syncani.com";

/** A `Host` header carries a port; a hostname does not. Accept both. */
export function normaliseHost(host: string | null | undefined): string {
  if (!host) return "";
  return host.trim().toLowerCase().split(":")[0];
}

export function isCanonicalHost(host: string | null | undefined): boolean {
  const hostname = normaliseHost(host);
  return CANONICAL_HOSTS.some((canonical) => hostname === canonical);
}

/** The origin a page names as itself: always the one public address. */
export function siteOrigin(_host?: string | null): string {
  return SITE_ORIGIN;
}
